import createLucideIcon from '../createLucideIcon';

const AlertTriangle = createLucideIcon('AlertTriangleIcon', [
  [
    'path',
    {
      d: 'm21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z',
      key: 'c3ski4',
    },
  ],
  ['line', { x1: '12', y1: '9', x2: '12', y2: '13', key: 'mb7vjk' }],
  ['line', { x1: '12', y1: '17', x2: '12.01', y2: '17', key: 'kdstpg' }],
]);

export default AlertTriangle;
